import log from 'salvo-lite/log'
import axios from 'axios'
import Queue from '../helpers/Queue.js'
import Helpers from '../helpers/Helpers.js'

class AjaxCart {
    constructor (theme, elem) {
        this.theme = theme
        this._elem = elem
        this._queue = new Queue()
        this._events = this.createEvents()
        if (this._elem.nodeName === 'FORM') {
            this._button = this._elem.querySelector('button[type="submit"]')
        } else {
            this._button = this._elem
        }
        this._variantID = null
        this._quantity = null
        this._properties = null
        this._additionalProducts = []
        this.addingText = 'Adding...'
        this.addedText = 'Added!'
        log.debug(this.constructor.name, 'Constructed', this)
    }

    setFields () {
        this._variantID = this.getVariantID()
        this._quantity = this.getQuantity()
        this._properties = this.getProperties()
        this._additionalProducts = this.getAdditonalProducts()
    }

    onInit () {
        log.debug(this.constructor.name, 'Initiating')
        this.setFields()
        if (this._elem.nodeName === 'FORM') {
            this._elem.addEventListener('submit', (e) => {
                e.preventDefault()
                this.addToCart()
            })
        } else {
            this._elem.addEventListener('click', (e) => {
                e.preventDefault()
                this.addToCart()
            })
        }
        this._elem.setAttribute('ajax-cart-initiated', true)
        log.debug(this.constructor.name, 'Initiated')
    }

    addToCart () {
        let originalText = this._button.innerHTML
        this._queue.enqueue(() => {
            this._button.innerHTML = this.addingText
            this.setFields()
            return axios.post('/cart/add.js', {
                id: this._variantID,
                quantity: this._quantity,
                properties: this._properties
            })
        })
        for (let additional of this._additionalProducts) {
            this._queue.enqueue(() => {
                return axios.post('/cart/add.js', {
                    id: additional.id,
                    quantity: additional.quantity,
                    properties: additional.properties
                })
            })
        }
        this._queue.enqueue(() => {
            log.debug(this.constructor.name, 'Added item')
            this._button.innerHTML = this.addedText
            setTimeout(() => {
                this._button.innerHTML = originalText
            }, 2500)
            document.dispatchEvent(this._events.addedItem)
        })
    }

    getQuantity (parentElem = this._elem) {
        let quantityElems = parentElem.querySelectorAll("[name='quantity']")
        if (quantityElems.length === 0) return parentElem.dataset.quantity ? parseInt(parentElem.dataset.quantity) : 1
        for (let elem of quantityElems) {
            if ((!Helpers.hasParent(elem, '[data-additional-product]') && parentElem === this._elem) || parentElem !== this._elem) {
                return parseInt(elem.value)
            }
        }
        return 1
    }

    getProperties (parentElem = this._elem) {
        let properties = {}
        let propElems = parentElem.querySelectorAll('[name^="properties"]')
        for (let propElem of propElems) {
            // Just accept it
            if ((!Helpers.hasParent(propElem, '[data-additional-product]') && parentElem === this._elem) || parentElem !== this._elem) {
                let name = propElem.getAttribute('name').split('[')[1].split(']')[0]
                properties[name] = propElem.value
            }
        }
        return properties
    }

    getVariantID (parentElem = this._elem) {
        let idElems = parentElem.querySelectorAll('[name="id"]')
        if (idElems.length === 0) return parentElem.dataset.variantId ? parseInt(parentElem.dataset.variantId) : false
        for (let elem of idElems) {
            if ((!Helpers.hasParent(elem, '[data-additional-product]') && parentElem === this._elem) || parentElem !== this._elem) {
                if (elem.type === 'checkbox' && !elem.checked) {
                    return false
                } else {
                    return elem.value
                }
            }
        }
        return false
    }

    getAdditonalProducts () {
        let additional = []
        let additonalElems = this._elem.querySelectorAll('[data-additional-product]')
        for (let additonalElem of additonalElems) {
            let variantId = this.getVariantID(additonalElem)
            if (variantId === false) continue
            additional.push({
                id: variantId,
                quantity: this.getQuantity(additonalElem),
                properties: this.getProperties(additonalElem)
            })
        }
        return additional
    }

    createEvents () {
        return {
            addedItem: new Event('added-item')
        }
    }
}

export default AjaxCart



// WEBPACK FOOTER //
// ./src/resources/scripts/components/AjaxCart.js